import React, {forwardRef, useImperativeHandle} from 'react';
import TextField from "@mui/material/TextField";

const inputType = "outlined";

let EditTransactionForm = (props, ref) => {
    const [id, setId] = React.useState("");
    const [type, setType] = React.useState("");
    const [client, setClient] = React.useState({});
    const [agent, setAgent] = React.useState({});
    const [reference, setReference] = React.useState("");
    const [status, setStatus] = React.useState("");
    const [message, setMessage] = React.useState("");
    const [amount, setAmount] = React.useState("");
    const [createdAt, setCreatedAt] = React.useState("");
    const [updatedAt, setUpdatedAt] = React.useState("");

    useImperativeHandle(ref, () => ({
        getValues: () => {
            return ({id, status});
        },
        reinit: () => {
            setId("");
            setType("");
            setClient({});
            setAgent({});
            setReference("");
            setStatus("");
            setAmount("");
            setUpdatedAt("");
            setCreatedAt("");
            setMessage("");
        }
    }));

    React.useEffect(() => {
        let { data } = props;
        if(data) {
            setId(data.id);
            setType(data.type);
            setClient(data.client);
            setAgent(data.agent);
            setReference(data.request_data);
            setStatus(data.status);
            setAmount(`${data.amount} ${data?.currency?.name}`);
            setCreatedAt(data.created_at);
            setUpdatedAt(data.updated_at);
        }
    }, [props.data]);

    return (
        <div>
            <div className="text-left">
                <div className="col-span-2">
                    <p className="mb-2 text-[14px] __ellipsis">{type} - {amount}</p>
                </div>
            </div>
            <div className="__line __fist">
                <input
                    label={"Amount"}
                    value={amount}
                    variant={inputType}
                    readOnly={true}
                    className="__form-input"/>
            </div>
            <div className="__line __fist">
                <label>{"Status"}</label>
                <select value={status} onChange={(e) => setStatus(e.target.value)} className="__form-input" variant={inputType}>
                    <option value={status}>{status}</option>
                    <option value="SUCCESS">SUCCESS</option>
                    <option value="CANCELLED">CANCELLED</option>
                    <option value="FAILED">FAILED</option>
                    <option value="EXPIRED">EXPIRED</option>
                </select>
            </div>
        </div>
    );
};

export default forwardRef(EditTransactionForm);